import React, { useState } from 'react';
import { Shield, Lock, ArrowRight, Zap, Globe, FileCheck } from 'lucide-react';

const Login = ({ onLogin }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code })
      });

      const data = await response.json();
      
      if (response.ok && (data.Success || data.success)) {
        onLogin(data.User || data.user);
      } else {
        setError(data.Message || data.message || 'Access Denied: Invalid Code');
      }
    } catch (err) {
      setError('Connection failed. Server offline.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      {/* Animated Background Blobs */}
      <div className="auth-bg-blob" style={{ top: '10%', left: '10%' }}></div>
      <div className="auth-bg-blob" style={{ bottom: '10%', right: '10%', animationDelay: '-5s', background: 'radial-gradient(circle, rgba(16, 185, 129, 0.2) 0%, rgba(16, 185, 129, 0) 70%)' }}></div>
      
      <div style={{ position: 'absolute', top: '2rem', left: '2rem', display: 'flex', alignItems: 'center', gap: '0.75rem', zIndex: 20 }}>
         <img src="https://intechronix.com/images/logo.svg" alt="Intechronix" style={{ height: '100px', filter: 'brightness(0) invert(1)' }} />
         <span style={{ color: 'white', fontWeight: 'bold', fontSize: '1.2rem', letterSpacing: '1px' }}>INTECHRONIX</span>
      </div>

      <div className="layout-grid premium-container" style={{ position: 'relative', zIndex: 10, width: '100%', alignItems: 'center' }}>
        
        {/* Left Side: Marketing/Info */}
        <div style={{ color: 'white', paddingRight: '2rem' }} className="no-print">
          <div style={{ display: 'inline-flex', padding: '0.5rem 1rem', background: 'rgba(255,255,255,0.1)', borderRadius: '20px', fontSize: '0.8rem', fontWeight: 'bold', color: 'var(--primary)', marginBottom: '1.5rem', border: '1px solid rgba(255,255,255,0.1)' }}>
            <Zap size={14} style={{ marginRight: '0.5rem' }} /> NEXT-GEN INVOICING ENGINE
          </div>
          <h1 style={{ fontSize: '3.5rem', color: 'white', marginBottom: '1.5rem', lineHeight: '1.1' }}>
            Professional Invoicing <br/>
            <span style={{ color: 'var(--primary)' }}>Redefined.</span>
          </h1>
          <p style={{ fontSize: '1.1rem', color: '#94a3b8', marginBottom: '2.5rem', lineHeight: '1.6', maxWidth: '500px' }}>
            A secure, multi-tenant ecosystem for Intechronix clients to generate, manage, and track GST-compliant invoices with state-of-the-art templates.
          </p>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
              <div style={{ color: 'var(--primary)', background: 'rgba(79, 70, 229, 0.1)', padding: '0.75rem', borderRadius: '12px' }}><Globe size={24} /></div>
              <div>
                <div style={{ fontWeight: '600' }}>Multi-Tenant</div>
                <div style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Secure Client Data</div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
              <div style={{ color: 'var(--secondary)', background: 'rgba(16, 185, 129, 0.1)', padding: '0.75rem', borderRadius: '12px' }}><FileCheck size={24} /></div>
              <div>
                <div style={{ fontWeight: '600' }}>GST Ready</div>
                <div style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Verified Compliance</div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Login Card */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div className="glass-card animate-fade-in">
            <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
              <div style={{ display: 'inline-flex', background: 'var(--primary)', padding: '1.25rem', borderRadius: '20px', color: 'white', marginBottom: '1.5rem', boxShadow: '0 10px 20px rgba(79, 70, 229, 0.3)' }}>
                <Lock size={32} />
              </div>
              <h2 style={{ fontSize: '1.75rem', fontWeight: '700', marginBottom: '0.5rem' }}>Secure Portal</h2>
              <p style={{ color: '#94a3b8' }}>Enter authentication code to proceed</p>
            </div>
            
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '2rem' }}>
                <input
                  type="password"
                  className="auth-form-input"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  placeholder="••••••"
                  required
                />
              </div>
              
              {error && (
                <div style={{ background: 'rgba(239, 68, 68, 0.1)', border: '1px solid rgba(239, 68, 68, 0.2)', color: '#f87171', padding: '0.75rem', borderRadius: '12px', marginBottom: '1.5rem', fontSize: '0.85rem', textAlign: 'center' }}>
                  {error}
                </div>
              )}
              
              <button type="submit" className="btn-primary" disabled={isLoading} style={{ height: '3.5rem', borderRadius: '14px', fontSize: '1.1rem' }}>
                {isLoading ? 'Decrypting Access...' : (
                  <>
                    Initialize Dashboard <ArrowRight size={18} style={{ marginLeft: '0.75rem' }} />
                  </>
                )}
              </button>
            </form>
            
            <div style={{ marginTop: '2rem', textAlign: 'center', fontSize: '0.8rem', color: '#64748b' }}>
              © 2026 INTECHRONIX. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
